import React from 'react';
import { useMessageGetter, Message } from '@messageformat/react';
import { Action } from '@op/opds.opux';
import { space } from '@op/opds.tokens';

const Footer = (props) => {
    const msg = useMessageGetter('fp');
    return (
        <footer id='fullpagelogin-footer'>
            <div id='fullpagelogin-footer-content'>
                <div style={{ marginTop: space.small }}>
                    <div className='fullpagelogin-footer-link'>
                        <Action id='footer-dataprotection-link' href='https://www.op.fi/tietosuoja?icmp=yl-ft-tietosuoja' external>
                            <Message id='fp.footer.dataprotectionLinkText' />
                        </Action>
                    </div>
                    <div className='fullpagelogin-footer-divider' />
                    <div className='fullpagelogin-footer-link'>
                        <Action id='footer-accessibility-link' href={msg('footer.accessibilityLinkTarget')} external>
                            <Message id='fp.footer.accessibilityLinkText' />
                        </Action>
                    </div>
                    <div className='fullpagelogin-footer-divider' />
                    <div className='fullpagelogin-footer-link'>
                        <Action id='footer-terms-link' href='https://www.op.fi/kayttoehdot?icmp=yl-ft-kayttoehdot' external>
                            <Message id='fp.footer.termsLinkText' />
                        </Action>
                    </div>
                </div>
                <div style={{ marginTop: space.small }}>
                    <div id='fullpagelogin-footer-copyright' className='opux-color-fg-hint-gray'>
                        <Message id='fp.footer.copyrightText' />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
